<script setup lang="ts"></script>

<template>
    <svg
        v-if="app_design_type === 'mguu'"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.49984 11.6666C2.96007 11.6666 3.33317 12.0397 3.33317 12.5V15.8333C3.33317 16.0543 3.42097 16.2663 3.57725 16.4225C3.73353 16.5788 3.94549 16.6666 4.1665 16.6666H15.8332C16.0542 16.6666 16.2661 16.5788 16.4224 16.4225C16.5787 16.2663 16.6665 16.0543 16.6665 15.8333V12.5C16.6665 12.0397 17.0396 11.6666 17.4998 11.6666C17.9601 11.6666 18.3332 12.0397 18.3332 12.5V15.8333C18.3332 16.4963 18.0698 17.1322 17.6009 17.6011C17.1321 18.0699 16.4962 18.3333 15.8332 18.3333H4.1665C3.50346 18.3333 2.86758 18.0699 2.39874 17.6011C1.9299 17.1322 1.6665 16.4963 1.6665 15.8333V12.5C1.6665 12.0397 2.0396 11.6666 2.49984 11.6666Z"
            fill="#8E8E9D"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.24391 7.74404C5.56935 7.4186 6.09699 7.4186 6.42243 7.74404L9.99984 11.3214L13.5772 7.74404C13.9027 7.4186 14.4303 7.4186 14.7558 7.74404C15.0812 8.06947 15.0812 8.59711 14.7558 8.92255L10.5891 13.0892C10.2637 13.4147 9.73602 13.4147 9.41058 13.0892L5.24391 8.92255C4.91848 8.59711 4.91848 8.06947 5.24391 7.74404Z"
            fill="#8E8E9D"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.99984 1.66663C10.4601 1.66663 10.8332 2.03972 10.8332 2.49996V12.5C10.8332 12.9602 10.4601 13.3333 9.99984 13.3333C9.5396 13.3333 9.1665 12.9602 9.1665 12.5V2.49996C9.1665 2.03972 9.5396 1.66663 9.99984 1.66663Z"
            fill="#8E8E9D"
        />
    </svg>

    <svg
        v-else
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 17.5H18V19.5H0V17.5ZM10 11.672L16.071 5.6L17.485 7.014L9 15.5L0.515 7.015L1.929 5.6L8 11.67V0.5H10V11.672Z"
            fill="currentColor"
        />
    </svg>
</template>
